import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';
import styled from 'styled-components';
import StarSelector from '../../SolvPatternLibrary/StarSelector';
import { colors } from '../../../constants/colors';
import { fontSize, fontFamily } from '../../../constants/text';
import { biggerThanOrEqualTo, smallerThanOrEqualTo } from '../../../core/util/styledComponents';
import { PRIMARY_RATING } from './PrimaryRatingSelector';

const Divider = styled.div`
  height: 1px;
  background-color: ${colors.dorianGrey};
  display: block;
  margin: 0 20px;

  ${biggerThanOrEqualTo.sm`
    width: 100%;
    margin: 0 auto;
  `}
`;

const Root = styled.div`
  padding: 26px 20px;
  text-align: center;
`;

const Title = styled.h1`
  margin: 0 auto 20px;
  display: block;
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.large};
  color: ${colors.blueMonday};

  ${smallerThanOrEqualTo.sm`
    font-size: ${fontSize.medium};
  `}
`;

const RatingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 475px;
  margin: 0 auto;
  padding-bottom: 20px;

  ${biggerThanOrEqualTo.sm`
    padding-bottom: 30px;
  `}

  :last-child {
    padding-bottom: 0;
  }
`;

const RatingCategory = styled.h2`
  display: block;
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.default};
  color: ${colors.blueMonday};
  align-self: center;
  text-align: left;

  ${smallerThanOrEqualTo.sm`
    font-size: ${fontSize.mediumSmall};
  `}
`;

const CenteredStars = styled(StarSelector)`
  align-self: center;
`;

export const BOOK = 'Finding & booking appointments';
export const TOOLS = 'Tools to manage my healthcare';
export const NAVIGATE = 'Ability to find what I needed';
export const FEEL = 'Look and feel';

const SECONDARY_RATINGS = [BOOK, TOOLS, NAVIGATE, FEEL];

export default class SecondaryStarSelectors extends PureComponent {
  static propTypes = {
    maryMagicSurvey: PropTypes.object,
    onChange: PropTypes.func,
  };

  render() {
    const { maryMagicSurvey, onChange } = this.props;

    return (
      <Collapse in={!!maryMagicSurvey[PRIMARY_RATING]} timeout="auto">
        <Fragment>
          <Divider />
          <Root>
            <Title>How would you rate the following?</Title>
            {SECONDARY_RATINGS.map(genre => (
              <RatingContainer key={genre}>
                <RatingCategory>{genre}</RatingCategory>
                <CenteredStars
                  starWidth={29}
                  rating={maryMagicSurvey[genre]}
                  onChange={value => onChange({ value, genre })}
                />
              </RatingContainer>
            ))}
          </Root>
        </Fragment>
      </Collapse>
    );
  }
}
